import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ACL } from 'shared/constants';
import aclService from 'shared/lib/acl';

import AgenziaKironService from 'shared/services/api/agenziakiron';
import DashboardNetwork from 'shared/services/rpc/dashboard-network';

import AgencyTable from '../AgencyTable';
import ResponsabileAreaFilterBar from '../ResponsabileAreaFilterBar';
import ResumeDataTable from '../ResumeDataTable';
import CollaboratoriInOutTable from '../CollaboratoriInOutTable';

const initialeResumeObject = {
  agencyNumber: '- - -',
  collaboratori: '- - -',
  tutor: '- - -',
  coordinatrici: '- - -',
};

const initialAgencyObject = [
  {
    name: '- - -',
    profile: '- - -',
    role: '- - -',
    tutoring: '- - -',
    experience: '- - -',
    payin: '- - -',
  },
];

export class NetworkDashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      areDataLoading: false,
      selectedResponsabileArea: '',

      agenciesOptions: [],
      areAgenciesLoading: false,
      areAgencyDataloading: false,
      selectedAgency: '',

      resumeData: initialeResumeObject,
      areResumeDataLoading: false,

      agencyData: initialAgencyObject,
    };
  }

  componentDidMount() {
    if (!aclService.check(this.props.auth, ACL.CAN_VIEW_SECTION_GESTIONE_RETE_ALL_TABS)) {
      this.loadAgenciesOptionsForSenior();
    }
  }

  onChangeResposabileArea = (value) => {
    this.setState({ selectedResponsabileArea: value, agencyData: initialAgencyObject });
    this.loadAgenciesOptions(value);
    this.getResumeData(value);
  };

  onChangeAgency = (value) => {
    this.setState({ selectedAgency: value });
    if (_.isEmpty(value)) {
      this.setState({ agencyData: initialAgencyObject });
    } else {
      this.getAgencyData(value);
    }
  };

  onReset = (value) => {
    this.onChangeResposabileArea(value);
    this.setState({ resumeData: initialeResumeObject, agencyData: initialAgencyObject });
  };

  getResumeData = (raId) => {
    this.setState({ resumeData: initialeResumeObject, areResumeDataLoading: true });
    DashboardNetwork.getDashboardData('resume-data', { raId })
      .then((res) =>
        this.setState({
          resumeData: {
            agencyNumber: res.agencyNumber,
            collaboratori: res.collaboratori,
            tutor: res.tutor,
            coordinatrici: res.coordinatrici,
          },
        })
      )
      .catch(() =>
        this.props.notification().addNotification({
          message: 'Errore nel caricamento dati della dashboard',
          level: 'error',
        })
      )
      .finally(() => this.setState({ areResumeDataLoading: false }));
  };

  getAgencyData = (agencyId) => {
    this.setState({ agencyData: initialAgencyObject, areAgencyDataloading: true });
    DashboardNetwork.getDashboardData('agency-data', { agencyId })
      .then((res) => {
        if (res && _.isArray(res.agencyData)) {
          const mappedAgencyValues = res.agencyData.map((collaboratore) => ({
            name: collaboratore.name,
            profile: collaboratore.profile,
            role: collaboratore.role,
            tutoring: collaboratore.tutoring,
            experience: collaboratore.experience,
            payin: collaboratore.payin,
          }));

          this.setState({ agencyData: mappedAgencyValues });
        }
      })
      .catch(() =>
        this.props.notification().addNotification({
          message: 'Errore nel caricamento dati della dashboard',
          level: 'error',
        })
      )
      .finally(() => this.setState({ areAgencyDataloading: false }));
  };

  loadAgenciesOptions = (raId) => {
    this.setState({ areAgenciesLoading: true, selectedAgency: '' });
    AgenziaKironService.getAgenzieByRAOptionsValue(raId)
      .then((res) => this.setState({ agenciesOptions: res.options }))
      .finally(() => this.setState({ areAgenciesLoading: false }));
  };

  loadAgenciesOptionsForSenior = () => {
    this.setState({ areAgenciesLoading: true, selectedAgency: '' });

    const options = [];

    this.props.auth.agenzie.list.forEach((obj) => {
      options.push({ key: obj.id, value: obj.id, text: `${obj.codice} - ${obj.nome}` });
    });

    this.setState({ agenciesOptions: options, areAgenciesLoading: false });
  };

  render() {
    return (
      <div>
        <Helmet>
          <title>Gestione rete - Dashboard</title>
          <meta name="description" content="Gestione rete - Dashboard" />
        </Helmet>

        {aclService.check(this.props.auth, ACL.CAN_VIEW_SECTION_GESTIONE_RETE_ALL_TABS) && (
          <div>
            <ResponsabileAreaFilterBar
              auth={this.props.auth}
              onChangeResposabileArea={this.onChangeResposabileArea}
              onReset={this.onReset}
              selectedResponsabileArea={this.state.selectedResponsabileArea}
            />
            <ResumeDataTable
              resumeData={this.state.resumeData}
              areResumeDataLoading={this.state.areResumeDataLoading}
            />
            <CollaboratoriInOutTable raId={this.state.selectedResponsabileArea} />
          </div>
        )}

        <AgencyTable
          agencyData={this.state.agencyData}
          areAgenciesLoading={this.state.areAgenciesLoading}
          areAgencyDataloading={this.state.areAgencyDataloading}
          agenciesOptions={this.state.agenciesOptions}
          onChangeAgency={this.onChangeAgency}
          selectedAgency={this.state.selectedAgency}
        />
      </div>
    );
  }
}

NetworkDashboard.propTypes = {
  /** Object with data of logged user */
  auth: PropTypes.object,
  /** Function for call the notification system */
  notification: PropTypes.func,
};

export default NetworkDashboard;



// WEBPACK FOOTER //
// ./app/components/NetworkDashboard/Dashboard/index.js